
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'ปักหมุด',
	'find_label': 'ค้นหา',
	'findCancelLabel': 'ยกเลิก',
	'dataPaneLabel': 'ข้อมูล',
	'sourcePaneLabel': 'เลือกแหล่งที่มา',
	'sourcePaneContentLabel': 'เลือกแหล่งที่มา',
	'emptySourcePaneTitle': 'เลือกแหล่งที่มา',
	'emptySourcePaneCaption': 'คลิกเลื่อกแหล่งข้อมูลที่จะเพิ่มข้อมูลเพื่อใช้สร้างแดชบอร์ด',
	'addDataSource': 'เลือกแหล่งที่มา',
	'addDataDashboardCoachMarkContents': 'ลากและดร็อปข้อมูจากพาเนลข้อมูลบนแดชบอร์ดของคุณ',
	'addDataStoryCoachMarkContents': 'ลากและปล่อยจากพาเนลข้อมูลลงบนเรื่องของคุณ',
	'addDataCoachMarkTitle': 'เพิ่มข้อมูล',
	'selectSourcesText': 'เลือกและเพิ่มแหล่งข้อมูลเพื่อสร้าง %{app} ของคุณ',
	'selectSourcesLabel': 'เลือกแหล่งที่มา',
	'dataPreparationTitle': 'การเตรียมข้อมูล',
	'dataPreparationCaption': 'จะมีการแสดงข้อมูลที่นี่เมื่อการเตรียมข้อมูลเสร็จสมบูรณ์',
	'dataPreparationProgress': '%{percentage}% ที่เตรียมไว้แล้ว ...',
	'dataPreparationSourceError': 'การเตรียมข้อมูลสำหรับ "%{sourceName}" ไม่เสร็จสมบูรณ์',
	'dataPreparationStarted': 'การเตรียมข้อมูลสำหรับ "%{sourceName}" กำลังดำเนินอยู่ คุณลักษณะของแดชบอร์ดจะพร้อมใช้งานเมื่อการเตรียมข้อมูลเสร็จสมบูรณ์',
	'dataPreparationComplete': 'การเตรียมข้อมูลสำหรับ "%{sourceName}" เสร็จสมบูรณ์ ขณะนี้พร้อมใช้งานกับคุณลักษณะของแดชบอร์ดทั้งหมดแล้ว',
	'preparingData': 'กำลังเตรียมข้อมูล...',
	'moserUnsupportedSourceType': 'ไม่รองรับชนิดของแหล่งข้อมูลนี้',
	'errorSourcesTitle': 'ไม่สามารถโหลดแผนผังข้อมูล',
	'errorLoadingDataSources': 'มีข้อผิดพลาดเกิดขึ้นขณะโหลดรายการชุดข้อมูล',
	'errorLoadingDataTree': 'เกิดข้อผิดพลาดขณะโหลดแผนผัง',
	'dataSetPaneLastUpdated': 'อัพเดตล่าสุด: %{date}',
	'dataSourcePaneDateUnknown': 'ไม่รู้จัก',
	'moreTitle': 'เพิ่มขึ้น',
	'backLabel': 'ย้อนกลับ',
	'addDataSourceDialogTitle': 'เลือกแหล่งที่มา',
	'addDataSourceDialogButtonLabel': 'เพิ่ม',
	'dlg_use': 'ใช้',
	'dlg_RelinkDataSourceTitle': 'แทนที่ชุดข้อมูล "%{dataSourceName}" ด้วย ...',
	'propertiesDialogTitle': 'คุณสมบัติ',
	'missingDataSetData': 'ข้อมูลสำหรับชุดข้อมูลนี้ไม่พร้อมใช้งาน รีเฟรชชุดข้อมูล หรือติดต่อผู้ดูแลระบบของคุณสำหรับการเข้าถึงแหล่งข้อมูล',
	'errorMessageTitle': 'ข้อผิดพลาด',
	'calculation_navigation_in_use': 'การลบการคำนวณ การกรอง หรือพาธการนำทางจะทำให้วิชวลไลเซชันทั้งหมดที่อ้างถึงไอเท็มที่ลบใช้งานไม่ได้ คุณแน่ใจว่าต้องการลบหรือใช่ไม่',
	'delete_confirm': 'ยืนยันการลบ',
	'previewUnavailable': 'ถาดข้อมูลและตัวกรองโกลบอลไม่พร้อมใช้งานสำหรับแพ็กเกจชนิดนี้',
	'contextualGridTabName': 'ข้อมูลวิชวลไลเซชัน',
	'DATA_TRAY_no_data_text': 'คุณไม่มีข้อมูลใดๆอยู่ในปัจจุบัน',
	'contextualGridMenuLabel': 'เมนูข้อมูลวิชวลไลเซชัน',
	'contextualGridExport': 'เอ็กซ์พอร์ต',
	'nullValueText': 'Null',
	'relationships_title': 'ความสัมพันธ์',
	'forecastDetailsTabName': 'รายละเอียดสถิติการคาดการณ์',
	'forecastDetailsModelLabel': 'โมเดล',
	'forecastDetailsQualityMetricLabel': 'มาตรวัดที่แม่นยำ',
	'forecastDetailsSmoothingCoefLabel': 'พารามิเตอร์',
	'forecastDetailsDiagnostics': 'การวินิจฉัย',
	'forecastDetailsForecastLabel': 'คาดการณ์ล่วงหน้า',
	'forecastDetailsStatusLabel': 'สถานะ',
	'forecastDetailsAccuracyPercentLabel': 'ความแม่นยำ %',
	'forecastDetailsTrendLabel': 'แนวโน้ม',
	'forecastDetailsSeasonLabel': 'ฤดูกาล',
	'forecastDetailsSeasonalPeriodLabel': 'ระยะเวลาตามฤดูกาล',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'ไม่มีจำนวนนับ',
	'forecastDetailsSeriesLengthLabel': 'ความยาวของซีรีย์',
	'forecastDetailsIgnoredPeriods': 'ช่วงเวลาที่ละเว้น',
	'forecastDetailsTrendStrength': 'ความแข็งแรงของแนวโน้ม',
	'forecastDetailsSeasonalityStrength': 'ความแข็งแรงตามฤดูกาล',
	'forecastDetailsTimeDeltaUnit': 'ช่วงวันที่ / เวลา',
	'forecastDetailsNotes': 'บันทึก',
	'DatasetRefresh_AmbiguousConnection': ' ใช้ \'แก้ไขชุดข้อมูล\' เพื่อแก้ปัญหาการเชื่อมต่อดังต่อไปนี้: %{errorMessage}'
});
